module.exports = __webpack_public_path__ + "static/media/completed.cd7d3d9b.svg";